<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid pb-4" style="background-color: white">
            <h2 style="text-align: center" class="pt-4">บันทึกค่าใช้จ่ายร้านค้า</h2>
            <br>
            <div class="col-12 text-center">
                <date-picker
                    :lang="lang"
                    type="date"
                    class="w-25 text-center"
                    :format="changeFormat"
                    v-model="date"
                    placeholder="วันที่">
                </date-picker>
            </div>
            <div class="table mt-4">
                <table class="table-borderless" align="center">
                    <tr v-for="(detail,index) in form">
                        <td width="200">รหัสพนักงาน</td>
                        <td width="250">
                            <multiselect
                                v-model="detail.employee"
                                :options="optionEmployee"
                                placeholder="เลือกพนักงาน"
                                select-label=""
                                deselectLabel=""
                                :customLabel="employeeLabel"
                                track-by="id">
                            </multiselect>
                        </td>

                        <td width="100">จำนวน</td>
                        <td width="250">
                            <input v-model="detail.amount"
                                   type="number" class="form-control"/>
                        </td>
                        <td width="100"><label>บาท</label></td>
                        <td width="100">
                            <!--เพิ่ม-->
                            <button type="button" class="btn btn-primary"
                                    @click="addShoppingDetails"
                                    v-if="form.length == index+1">
                                <icon name="plus"></icon>
                            </button>
                            <!--ลบ-->
                            <button type="button" class="btn btn-danger"
                                    @click="removeShoppingDetails(index)"
                                    v-if="index+1 < form.length">
                                <icon name="trash"></icon>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="col text-center">
                <button type="button"
                        @click="saveShopping"
                        class="btn btn-success">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;
                &nbsp;
                <button type="button"
                        @click="goToShoppingList"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>

        </div>
        <!--            <pre class="alert-primary">{{form}}</pre>-->
    </div>

</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    name: "shopping-form",
    components: {
        Multiselect, DatePicker
    },
    created() {
        this.$store.dispatch('ShoppingEmployee/clearFormData');
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.optionEmployee = res;
        });
    },
    data() {
        return {
            optionEmployee: [],
            currentDate: "",
            date: '',
            items: [
                {
                    text: "รายการค่าใช้จ่ายร้านค้า",
                    to: {name: "shopping"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            form: state => {
                return state.ShoppingEmployee.shoppingEmployeeForm;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    methods: {
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        goToShoppingList() {
            this.$router.push({
                name: "shopping"
            })
            this.$store.dispatch('ShoppingEmployee/clearFormData');
        },
        showCancelModal() {
            this.$refs.confirm_cancel.show();
        },
        hideCancelModal() {
            this.$refs.confirm_cancel.hide();
        },
        addShoppingDetails() {
            this.$store.dispatch("ShoppingEmployee/addShoppingDetails");
        },
        removeShoppingDetails(index) {
            //console.log(index)
            this.$store.dispatch("ShoppingEmployee/removeShoppingDetails", index);
        },
        saveShopping() {
            if (!this.date) {
                alert('กรุณาเลือกวันที่');
            } else {
                this.form.forEach(detail => {
                    if (detail.employee != 0) {
                        detail.employee_id = detail.employee.id;
                    } else {
                        detail.employee_id = null;
                    }
                    detail.recorder = this.user.name;
                    this.currentDate = moment().format("YYYY-MM-DD");
                    detail.date = this.date ? moment(this.date).format("YYYY-MM-DD") : '';
                })
                //console.log(this.form);
                this.$store.dispatch('ShoppingEmployee/saveShoppingEmployee', {
                    id: "",
                    data: this.form
                }).then(() => {
                    this.$store.dispatch("ShoppingEmployee/setShoppingEmployee");
                })
                this.goToShoppingList();
            }
        },
    }
}
</script>

<style scoped>

</style>
